import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Row, Col, Input } from 'antd'; // Dodat Input
import { 
  EyeOutlined, 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  BoxPlotOutlined,
  SearchOutlined // Dodata ikonica
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MobileDashboard = () => {
  const [data, setData] = useState([]);
  const [stats, setStats] = useState({ total: 0, online: 0, offline: 0 });
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState(''); // State za pretragu
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await axios.get('/api/box/list/');
      const filteredBoxes = response.data.filter(box => box.id !== 294);
      
      const total = filteredBoxes.length;
      const online = filteredBoxes.filter(box => box.status === 'online').length;
      const offline = filteredBoxes.filter(box => box.status === 'offline').length;
      
      setData(filteredBoxes);
      setStats({ total, online, offline });
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  // Logika za filtriranje podataka na osnovu kucanja
  const filteredData = data.filter(item => {
    const name = (item.box_name || item.box_id || '').toString().toLowerCase();
    return name.includes(searchText.toLowerCase());
  });

  const getTempColor = (t) => {
    const val = parseFloat(t);
    if (isNaN(val)) return '#ffffff';
    if (val > 80) return '#ef4444'; 
    if (val > 75) return '#fbbf24'; 
    return '#34d399';               
  };

  const columns = [
    {
      title: 'Box Info',
      key: 'mobile_card',
      render: (record) => (
        <div className="m-mini-card">
          <div className="m-card-col main-info">
            <div className="m-box-top" onClick={() => navigate(`/screendetails/${record.id}`)} style={{ cursor: 'pointer' }}>
              <div className="status-dot" style={{ background: record.status === 'online' ? '#34d399' : '#ef4444' }}></div>
              <span className="box-name-text">{record.box_name || record.box_id}</span>
            </div>
            <div className="status-label" style={{ color: record.status === 'online' ? '#34d399' : '#ef4444' }}>
              {record.status.toUpperCase()}
            </div>
          </div>

          <div className="m-card-col seen-info">
            <div className="tiny-label">LAST SEEN</div>
            <div className="seen-data-row">
              <span className="date-val">{new Date(record.last_seen).toLocaleDateString('sr-RS', {day: '2-digit', month: '2-digit'})}</span>
              <span className="time-val">{new Date(record.last_seen).toLocaleTimeString('sr-RS', {hour: '2-digit', minute:'2-digit'})}</span>
            </div>
          </div>

          <div className="m-card-col temp-info">
            <div className="tiny-label">TEMP</div>
            <div className="tiny-value" style={{ color: getTempColor(record.cpu_temp) }}>
              {record.cpu_temp || 'N/A'}
            </div>
          </div>

          <div className="m-card-col action-btn">
            <Button 
              size="middle" 
              icon={<EyeOutlined />} 
              onClick={() => navigate(`/screendetails/${record.id}`)}
              className="view-btn-dark"
            >
              VIEW
            </Button>
          </div>
        </div>
      ),
    }
  ];

  return (
    <div className="mobile-dashboard-wrapper">
      <Row gutter={[8, 8]} style={{ marginBottom: '15px' }}>
        <Col span={24}>
          <div className="st-box" style={{ borderBottomColor: '#3b82f6' }}>
            <Space>
              <BoxPlotOutlined style={{ color: '#3b82f6', fontSize: '20px' }} />
              <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>Total:</span> 
              <span style={{ color: 'white', fontWeight: '900', fontSize: '22px' }}>{stats.total}</span>
            </Space>
          </div>
        </Col>
        <Col span={12}>
          <div className="st-box" style={{ borderBottomColor: '#34d399' }}>
            <Space>
              <CheckCircleOutlined style={{ color: '#34d399', fontSize: '18px' }} />
              <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>Online:</span>
              <span style={{ color: 'white', fontWeight: '900', fontSize: '20px' }}>{stats.online}</span>
            </Space>
          </div>
        </Col>
        <Col span={12}>
          <div className="st-box" style={{ borderBottomColor: '#ef4444' }}>
            <Space>
              <CloseCircleOutlined style={{ color: '#ef4444', fontSize: '18px' }} />
              <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>Offline:</span>
              <span style={{ color: 'white', fontWeight: '900', fontSize: '20px' }}>{stats.offline}</span>
            </Space>
          </div>
        </Col>
      </Row>

      {/* SEARCH POLJE */}
      <div style={{ marginBottom: '15px' }}>
        <Input
          placeholder="Pretraži boxove..."
          prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
          onChange={e => setSearchText(e.target.value)}
          className="m-search-input"
          allowClear
        />
      </div>

      <Table 
        dataSource={filteredData} // Koristi filtrirane podatke
        columns={columns} 
        pagination={false} 
        rowKey="id" 
        loading={loading} 
      />

      <style>{`
        .mobile-dashboard-wrapper { padding-bottom: 20px; }
        .st-box { background: #1e293b; padding: 15px; border-radius: 8px; border: 1px solid #334155; border-bottom: 5px solid; display: flex; justify-content: center; align-items: center; }
        
        /* STIL ZA SEARCH INPUT */
        .m-search-input {
          background: #1e293b !important;
          border: 1px solid #334155 !important;
          color: white !important;
          border-radius: 8px !important;
          height: 45px !important;
        }
        .m-search-input input {
          background: transparent !important;
          color: white !important;
        }
        .m-search-input .ant-input-clear-icon { color: #94a3b8 !important; }

        .ant-table { background: transparent !important; }
        .ant-table-thead { display: none !important; }
        .ant-table-tbody > tr > td { border: none !important; padding: 0 0 10px 0 !important; background: transparent !important; }

        .m-mini-card { 
          background: #1e293b; 
          border: 1px solid #475569; 
          border-radius: 10px; 
          padding: 12px; 
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .m-card-col { display: flex; flex-direction: column; min-width: 0; }
        .main-info { flex: 2.2; }
        .seen-info { flex: 1.8; }
        .temp-info { flex: 0.9; align-items: center; }
        .action-btn { flex: 0 0 auto; }

        .m-box-top { display: flex; align-items: center; gap: 8px; }
        .status-dot { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }
        .box-name-text { color: white !important; font-weight: 700; font-size: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .status-label { font-size: 11px; font-weight: 900; margin-left: 16px; letter-spacing: 0.5px; }

        .tiny-label { color: #ffffff !important; font-size: 10px; font-weight: 900; text-transform: uppercase; margin-bottom: 4px; border-bottom: 1px solid rgba(255,255,255,0.1); width: fit-content; }
        
        .seen-data-row { display: flex; gap: 8px; align-items: baseline; }
        .date-val { color: #ffffff !important; font-size: 13px; font-weight: 700; }
        .time-val { color: #ffffff !important; font-size: 12px; font-weight: 400; opacity: 1; }

        .tiny-value { font-size: 14px; font-weight: 800; }

        .view-btn-dark {
          background: #1e293b !important; 
          color: #94a3b8 !important; 
          border: 1px solid #334155 !important; 
          border-radius: 6px !important; 
          font-weight: bold !important; 
          font-size: 12px !important; 
          height: 34px !important;
          padding: 0 12px !important;
        }

        .ant-spin-dot-item { background-color: #3b82f6 !important; }
      `}</style>
    </div>
  );
};

export default MobileDashboard;